﻿
import { GroCommon } from './common';
import { TimeBookingFunction } from './time-booking';

$(document).ready(function () {
    var myListingBooking = new ListingBookingPage();
    myListingBooking.init();
    $(document).trigger("enhance.tablesaw");
});

var ListingBookingPage = function () {
    var dialogType = GroCommon.modalInfoClass;
    var lastSearchQuery = {};
    //search
    var doSearch = function () {
        TimeBookingFunction.blockUI();
        $('#SaveTable').hide();
        $('#updateListBtn').hide();

        var obj = {};
        obj.ResourceGroupId = $('#bl-resourceDrp').attr("data-value");
        obj.FromDate = $('#fromDateTxt').val();
        obj.ToDate = $('#toDateTxt').val();
        obj.RegNo = $('#RegNo').val();
        obj.CustomerNo = $('#customerNo').val();
        obj.IsInternal = $('#isInternal').val();
        obj.ReferenceType = '';
        obj.ReferenceNumber = '';
        obj.PurchseOrderLine = '';
        var containerDto = {};
        containerDto = obj;
        lastSearchQuery = obj;

        $.ajax({
            type: 'POST',
            url: '/api/list-booking/SearchBookings',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(containerDto),

            success: function (response) {
                searchComplete(response);
                TimeBookingFunction.unBlockUI();
            },
            error: function (response) {
                alert('Error: ' + response);
                $("#search-result-book-listing").hide();
                TimeBookingFunction.unBlockUI();
            }
        });

        var searchComplete = function (response) {
            $("#search-result-book-listing").html(response);
            if (response.resultSearchBookings == undefined) {
                $("#search-result-book-listing").show();
            } else {
                $("#search-result-book-listing").hide();
            }
            deleteBookingEvents();
            editBookingEvent();
            printPageEvents();
            $(document).trigger("enhance.tablesaw");
        };
    };
    //delete
    var deleteBooking = function (deleteButton) {
        var dataValues = $(deleteButton).parent().parent();

        var reservationId = dataValues.find("> #reservationId").html();
        var reservationDate = dataValues.find("#from-date").val();
        var time = dataValues.find("#from-time").val();
        var owner = dataValues.find("> #owner").html();
        var customerNo = dataValues.find("> #customer-number").html();

        var content = $("<p></p>");
        content.append('<span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>');
        content.append('Vill du verkligen radera bokningen<br \/> kl: ' + time + '?');
        TimeBookingFunction.clearContentToDeleteDialog();
        TimeBookingFunction.fillContentToDeleteDialog("Ta bort bokning?", content);
        $("#deleteDialog").find(".btn-ok").on("click", function () {
            deleteReservationProcessList(reservationId, owner, customerNo, reservationDate, time);
        });

        var deleteReservationProcessList = function (reservationId, owner, customerNo, reservationDate, time) {
            clearFormList();
            var o = {};
            o.reservationId = reservationId;
            o.owner = owner;
            o.customerNo = customerNo;
            o.dateRegistered = reservationDate + " " + time;
            o.isInternal = $('#isInternal').val();
            $.ajax({
                type: 'POST',
                url: '/api/time-booking/DeleteReservation',
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(o),

                success: function (response) { deletReservationSuccessList(response.deleteReservations); },
                error: function (response) { deletReservationErrorList(); }
            });

            var deletReservationSuccessList = function (response) {
                var content = $("<p></p>");
                for (var i = 0; i < response.length; i++) {
                    if (response[i].Status == 500) {
                        content.append('<span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>');
                    }
                    content.append(response[i].Message + '<br \/>');
                }
                TimeBookingFunction.clearContentToModal("#dialogArea");
                TimeBookingFunction.fillContentToModal("#dialogArea", "Borttagning", content, dialogType.error);

                doSearch();
                $('#SaveTable').hide();
                $('#updateListBtn').hide();
            };

            var deletReservationErrorList = function () {
                $('#SaveTable').hide();
                $('#updateListBtn').hide();
                alert('Fel uppstod vid anropet till tjänsten.');
            };
        };
    };
    //edit button
    var editBooking = function (editButton) {
        var editObj = {};
        var dataValues = $(editButton).parent().parent();
        editObj.resourceName = dataValues.find("#resourceName").val();
        editObj.itemName = dataValues.find("#itemName").val();
        editObj.weight = dataValues.find(">#weight").html();
        editObj.fromTime = dataValues.find("#from-time").val();
        editObj.itemNo = dataValues.find(">#itemNo").html();
        editObj.idLevnr = dataValues.find(">#leveransforsakransnr").html();
        editObj.idReg = dataValues.find(">#licensePlateNo").html();
        editObj.idOvrigt = dataValues.find("#note").val();
        editObj.idReminder = dataValues.find("#reminderMinutesBefore").val();
        editObj.idEpost = dataValues.find("#emailAddress").val();
        editObj.idMobil = dataValues.find("#mobileNo").val();
        editObj.reservationId = dataValues.find(">#reservationId").html();
        editObj.speditorNo = dataValues.find("#speditorNo").val();
        editObj.customerNo = dataValues.find(">#customer-number").html();
        editObj.customerName = dataValues.find("#customer-name").val();
        editObj.transportOrderNo = dataValues.find("#transportOrderNo").val();
        editObj.contractNo = dataValues.find("#contractNo").val();
        editObj.reminderEmail = dataValues.find("#reminderEmail").val();
        editObj.reminderSms = dataValues.find("#reminderSms").val();
        editObj.owner = dataValues.find(">#owner").html();
        editObj.dateRegistered = dataValues.find("#dateRegistered").val();
        editObj.displayMessage = 'Tid: ' + editObj.fromTime + ', Kund: ' + editObj.customerNo + ' ' + editObj.customerName + ', Bokningsnr: ' + editObj.reservationId + ', Artikel: ' + editObj.itemNo + ' ' + editObj.itemName + editObj.weight + '<br \/>Resurs: ' + editObj.resourceName;
        TimeBookingFunction.copyValuesToEnableEdit(editObj, true);
    };
    //update
    var updateReservationList = function () {
        var email = $('#IDEpost').val();
        var mobileNo = $('#IDMobil').val();
        var licensePlateNo = $('#IDReg').val();
        var leveransforsakransnummer = $('#IDLevnr').val();
        if (TimeBookingFunction.validateSaveTable(email, mobileNo, licensePlateNo, leveransforsakransnummer)) {
            var form = $('#form-list-booking');
            $.ajax({
                type: "POST",
                url: '/api/time-booking/UpdateReservation',
                data: form.serialize(),
                success: function (response) {
                    updateReservationListSuccess(response.updateReservations);
                },
                error: function (response) { updateReservationListError(response.updateReservations); }
            });
        }
        var updateReservationListSuccess = function (response) {
            var content = $("<p></p>");
            for (var i = 0; i < response.length; i++) {
                if (response[i].Status == 200) {
                    content.append(response[i].Message);
                } else {
                    content.append(response[i].ErrorMessage);
                }
                content.append('<br \/>');
            }
            TimeBookingFunction.clearContentToModal("#dialogArea");
            TimeBookingFunction.fillContentToModal("#dialogArea", "Bokningen uppdaterad", content, dialogType.error);
            clearFormList();

            $('#SaveTable').hide();
            $('#updateListBtn').hide();
            doSearch();
        };
        var updateReservationListError = function () {
            $('#SaveTable').hide();
            alert('updateReservationError');
            doSearch();
        };
    };

    var clearFormList = function () {
        $('.fieldToClearWithClearForm').val('');
        $('#SaveTable').hide();
        $('#updateListBtn').hide();

        $('#IDEpost').val($('#IDEpost_StartValue').val());
        $('#IDMobil').val($('#IDMobil_StartValue').val());
        $('#saveAction').val('New');

        $('#saveAction').val('New');
        $('#myDisplayMessage').html('');
        $('#displayMessageHeader').html('&nbsp;');
    };
    var printPageEvents = function () {
        function printData() {
            var divToPrint = document.getElementById('printable-table');
            var newWin = window.open("");
            newWin.document.write(divToPrint.innerHTML);
            newWin.document.close();
            newWin.focus();
            newWin.print();
            newWin.close();
        }

        var printBtn = $('#printLink');
        $(printBtn).unbind("click");
        $(printBtn).click(function () {
            printData();
        });
    };
    var searchBookingEvents = function () {
        $('#search-booking-button').click(function (e) {
            //var reRegnr = /^([a-zA-Z]{3}\d{3})+$/;
            var regnr = $("#RegNo").val();
            var custNo = $("#CustomerNo").val();
            var result = true;

            //if (regnr && !reRegnr.test(regnr)) {
            //    result = false;
            //    $("#RegNo").addClass("error");
            //    $("#RegNo-error").show();
            //}

            if (result) {
                $("#RegNo").removeClass("error");
                $("#RegNo-error").hide();
                doSearch();
            }
            e.preventDefault();
        });
    };
    var deleteBookingEvents = function () {
        var deleteBtn = $(".boka-listing-deleteBtn");
        $(deleteBtn).unbind("click");
        $(deleteBtn).click(function (e) {
            deleteBooking($(this));
            e.preventDefault();
        });
    };
    var editBookingEvent = function () {
        var editBtn = $(".boka-listing-editBtn");
        $(editBtn).unbind("click");
        $(editBtn).click(function (e) {
            editBooking($(this));
            TimeBookingFunction.clearValidateSaveTable();
            e.preventDefault();
        });
    };
    var updateReservationListEvent = function () {
        $('#updateListBtn').unbind('click');
        $('#updateListBtn').click(function () {
            updateReservationList();
        });
    };
    var init = function () {
        searchBookingEvents();
        updateReservationListEvent();
    };

    return {
        init: init
    };
};
